export const PARTNER_TERMS_VERSION = "2026-10-03";
export const PARTNER_TERMS_URL = "https://lastgo.eu/obchodni-podminky-pro-partnery";
export const LEGAL_DOCUMENTS_URL = "https://lastgo.eu/pravni-dokumenty";
